<div class="d-flex flex-row align-items-center" [formGroup]="group">
    <ui-switch class="d-flex" [formControlName]="controlName"></ui-switch>
    <app-spacer [right]="10"></app-spacer>
    <span class="switch-label">{{ label }}</span>
</div>